import * as Style from "../style/StyledComponents";
import { abbreviateAddress, chain, getEtherscanAddressLink, getEtherscanTxnLink, getEtherscanContractLink, links } from "./Config";
import {useState, useEffect} from 'react'
import { useQueryClient } from '@tanstack/react-query'

//import { InjectedConnector } from 'wagmi/connectors/injected'
import { useConnect , useAccount, useDisconnect, useBalance } from 'wagmi'
import { usePrepareContractWrite, useWriteContract  , useReadContracts  } from 'wagmi'
//import { waitForTransaction, fetchBalance  } from '@wagmi/core'

import { injected } from 'wagmi/connectors'
import { ethers } from 'ethers';
import BigNumber from 'bignumber.js';

BigNumber.config({ EXPONENTIAL_AT: 50 })

const contractABI_MintFrontEnd = require("../abi/Gems.json");

const frontendContract = {
  address: process.env.REACT_APP_CONTRACT_FRONTEND,
  abi: contractABI_MintFrontEnd.abi,
}


const MINT_STATUS = {
  DISABLED:0,
  WHITELIST:1,
  PUBLIC:2
}

const MINT_STRING = [ "Disabled", "Whitelist Only", "Public"];

export const Mint = () => {

  const queryClient = useQueryClient();

  const { isConnected , address } = useAccount()
  const { disconnect } = useDisconnect()
  const { connect } = useConnect();

  // pulled onchain
  const [currentSupply, setCurrentSupply] = useState(0);
  const [maxSupply, setMaxSupply] = useState(1111);
  const [mintPrice, setMintPrice] = useState("1");
  const [mintCount, setMintCount] = useState(1);
  const [mintStatus, setMintStatus] = useState(0);
  const [maxPerWallet, setMaxPerWallet] = useState(1);
  const [maxMintAmount, setMaxMintAmount] = useState(1);
  
  // per user
  const [addressIsWhitelisted, setAddressIsWhitelisted] = useState(false);
  const [addressNumMinted, setAddressNumMinted] = useState(0);


  const [walletBalance, setWalletBalance] = useState("0.0");

  // calculated
  const [totalMintPrice, setTotalMintPrice] = useState("0.0");

  const { data:readData, isError:readError, isLoading:readIsLoading } = useReadContracts({
    query:{enabled: isConnected == true},
    contracts: [
      {
        ...frontendContract,
        functionName: 'totalSupply',
      },
      {
        ...frontendContract,
        functionName: 'MAX_TOKEN_SUPPLY',
      },
      {
        ...frontendContract,
        functionName: 'maxPerWallet',
      },
      {
        ...frontendContract,
        functionName: 'mintStatus',
      },
      {
        ...frontendContract,
        functionName: 'price',
      },

      {
        ...frontendContract,
        functionName: 'numMinted',
        args:[address],
      },

      {
        ...frontendContract,
        functionName: 'getNumMinted',
        args:[address],
      },

      {
        ...frontendContract,
        functionName: 'isWhitelist',
        args:[address],
      },
    ],
  });

  const { data: balance, queryKey } = useBalance({ 
    address: address,
    watch: true, 
  });

  useEffect(()=>{

    if (balance != null && isConnected && address) {
      const price = new BigNumber(parseInt(balance.value));
      const total = price.multipliedBy("1E-18").toFixed(4);
      setWalletBalance(total);
    }
  }, [balance, isConnected]);


  useEffect(()=>{
    if (readData != null) {
      console.log("Contract read:", readData);

      setCurrentSupply( parseInt(readData[0].result));
      setMaxSupply( parseInt(readData[1].result));
      setMaxPerWallet( parseInt(readData[2].result));
      setMaxMintAmount( parseInt(readData[2].result) - parseInt(readData[6].result));
      setMintStatus(readData[3].result);

      const price = new BigNumber(parseInt(readData[4].result));
      const total = price.multipliedBy("1E-18");
      setMintPrice(total.toString());

      setAddressNumMinted( parseInt(readData[6].result));
      setAddressIsWhitelisted( readData[7].result);
    }

  }, [readData]);


  const { data, isPending, isSuccess, error, isError, writeContract, reset } = useWriteContract ({
    address: process.env.REACT_APP_CONTRACT_FRONTEND,
    abi: frontendContract.abi,
    functionName: mintStatus == MINT_STATUS.WHITELIST ? 'mintGemsWhitelist' : 'mintGems',
    chainId: chain.id,
    account: address,

    onSettled(data, error) {
      console.log('Transaction Settled', { data, error })
    },
  });

  useEffect(()=>{
    const price = new BigNumber(mintPrice);
    const total = price.multipliedBy(mintCount);
    setTotalMintPrice(total.toString());
  },  [mintPrice, mintCount]);


  function onClickPlus() {
    setMintCount(Math.min(maxMintAmount, mintCount+1));
  }

  function onClickMinus() {
    setMintCount(Math.max(1, mintCount-1));
  }

  function onClickConnect() {
    console.log("CONNECT");
    connect({connector:injected()});
  }

  function onClickDisconnect() {
    console.log("Disconnect");
    disconnect();
    reset();
  }

  async function onClickMint() {
    reset();

    console.log(`Minting: mint(${mintCount}) with payable ${totalMintPrice} ETH`);
    writeContract({

          address: process.env.REACT_APP_CONTRACT_FRONTEND,
          abi: frontendContract.abi,
          functionName: mintStatus == MINT_STATUS.WHITELIST ? 'mintGemsWhitelist' : 'mintGems',
          chainId: chain.id,
          account: address,

          args: [mintCount],
          from: address,
          value: ethers.parseEther(totalMintPrice),
    });
  }

  return (
    <div>

    <>
        <Style.Button disabled>minted out!</Style.Button>
        <p style={{fontSize:"0.75em", marginTop:"5px"}}>✔️ 1111/1111 ( <a href={links.driptrade} target="_blank">Marketplace</a> )</p>
      </>

  
{/*
    {isConnected && <Style.SuccessMessage>ℹ️ Please make sure you have <a href="https://hyperevm-block-toggle.vercel.app/" target="_blank">BIG BLOCKS enabled</a> for your wallet prior to minting!</Style.SuccessMessage>}
*/}
{/*
{!isConnected && <><Style.Button onClick={onClickConnect}>connect</Style.Button><p style={{fontSize:"0.75em", marginTop:"5px", display:"none"}}>(Network: <a href={links.hyperliquid} target="_blank">{chain.name}</a>)</p></>}

    {isConnected && mintStatus==MINT_STATUS.DISABLED && <Style.Button disabled={true}>Minting not available</Style.Button>}
    {isConnected && mintStatus!=MINT_STATUS.DISABLED && currentSupply == maxSupply && <Style.Button disabled={true}>Minted Out</Style.Button>}

    {isConnected && mintStatus==MINT_STATUS.WHITELIST && !addressIsWhitelisted && currentSupply < maxSupply && <Style.Button disabled={true}>😥 Not Whitelisted</Style.Button>}
    {isConnected && mintStatus!=MINT_STATUS.DISABLED && currentSupply < maxSupply && addressNumMinted >= maxPerWallet && <Style.Button disabled={true}>You've max minted</Style.Button>}


    {isConnected && (mintStatus==MINT_STATUS.PUBLIC || (mintStatus==MINT_STATUS.WHITELIST && addressIsWhitelisted) ) && currentSupply < maxSupply && addressNumMinted < maxPerWallet && 
      <div style={{textAlign:"left"}}>
      <div style={{display:"flex", flexDirection:"row"}}>
        <Style.Button disabled={isPending} hidden={mintCount<=1} onClick={onClickMinus}>-</Style.Button>
        <Style.Button disabled={isPending} onClick={onClickMint}>💎 Mint {mintCount} </Style.Button>
        <Style.Button disabled={isPending} hidden={mintCount>=maxMintAmount || (currentSupply+mintCount+1 > maxSupply) } onClick={onClickPlus}>+</Style.Button>


        </div>

         <div style={{marginLeft:"0em"}}>
    <p style={{fontSize:"0.9em", fontFamily:"Header", fontWeight:"bold",color: "var(--black)"}}>✔️ Total: <span style={{fontSize:"1.3em", color: "var(--black)", fontWeight:"bold"}}>{totalMintPrice} {chain.nativeCurrency.symbol}</span></p>
    <p style={{marginLeft:"0.5em", fontSize:"0.65em", color: "var(--gray-600)"}}>({mintCount}💎 x {mintPrice} {chain.nativeCurrency.symbol} each)</p>
    </div>
    </div>
      }



    {isConnected && <div style={{marginTop:"1.5em", fontSize:"0.75em",textAlign:"left",}}>🟢 <strong>Connected</strong>: <a href={getEtherscanAddressLink(address)} target="_blank">{abbreviateAddress(address,5)}</a> (<a onClick={onClickDisconnect}>Disconnect</a>)</div>}
    {isConnected && <div style={{fontSize:"0.75em",textAlign:"left",}}>(Your Balance: <strong>{walletBalance} {chain.nativeCurrency.symbol}</strong>)</div>}
    {isConnected && 
      <div style={{marginTop:"1.2em", fontSize:"0.6em", textAlign:"left"}}>

        ▪ Mint Status: <strong>{MINT_STRING[mintStatus]}</strong>
        <br/>
         ▪ Mint Price (each): <strong>{mintPrice} {chain.nativeCurrency.symbol}</strong>
         <br/>
        ▪ Total Minted: 💎{currentSupply==maxSupply?"✔️ ":""}<strong>{currentSupply} / {maxSupply}</strong>
        <br/>
        ▪ Num Minted by You: 💎<strong>{addressNumMinted} (of {maxPerWallet} max)</strong>
        <br/>
        ▪ You're Whitelisted: <strong>{addressIsWhitelisted ? "✔️ Yes" : "😥 No"}</strong>
        <br/>
        
        ▪ Block Size: <strong>Small</strong>

      </div>
    }


    {isError && <Style.ErrorMessage>Error: {error.message}</Style.ErrorMessage>}

    {isSuccess && data != null && <Style.SuccessMessage><strong>✔️ Transaction Sent</strong>: <a href={getEtherscanTxnLink(data)} target="_blank">{abbreviateAddress(data, 7)}</a></Style.SuccessMessage>}
*/}
    </div>
  )
}
